// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"1942b5ed","307":"55a78265"}[chunkId] + ".chunk.js";
};